import { fetchWithTrace } from '../fetchWithTrace';

const API_Base = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function postJSON(path, body) {
    const token = localStorage.getItem('token');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    const { data } = await fetchWithTrace(`${API_Base}${path}`, {
        method: 'POST',
        credentials: 'include',
        headers,
        body: body ?? {},
    });
    return data;
}

export const AudioAPI = {
    generate: async ({ prompt, negative_prompt, seed }) => {
        try {
            const data = await postJSON('/api/music/generate', { prompt, negative_prompt, seed });
            return data.url; // Returns the GCS URL
        } catch (error) {
            console.error('AudioAPI generate error:', error);
            throw error;
        }
    },
    generateSpeech: async ({ text, voice, model }) => {
        try {
            const data = await postJSON('/api/tts/generate', { text, voice, model });
            return data.audioUrl;
        } catch (error) {
            console.error('AudioAPI generateSpeech error:', error);
            throw error;
        }
    }
};
